// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3aca7","selects":"Documents_selects__10IuV"};